import {
  REMOVE_MEMBER,
  REMOVE_PENDING_MEMBER,
  SHOW_REMOVE_MODAL,
  HIDE_REMOVE_MODAL,
} from './constants';

export function removeMember(permissionId, userId) {
  return {
    type: REMOVE_MEMBER,
    permissionId,
    userId,
  };
}

export function removePendingMember(invitationId) {
  return {
    type: REMOVE_PENDING_MEMBER,
    invitationId,
  };
}

export function showRemoveModal(id) {
  return {
    type: SHOW_REMOVE_MODAL,
    id,
  };
}

export function hideRemoveModal() {
  return {
    type: HIDE_REMOVE_MODAL,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-members-manage/actions.js
 **/